"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormClientResponseArraySchema = exports.FormClientResponseSchema = exports.ContentSchema = void 0;
const z = __importStar(require("zod"));
// Define the basic structure for each field
const FieldSchema = z.object({
    name: z.string(),
    order: z.string().or(z.number()).optional(), // Accept both string and number for order
    text: z.string().optional(),
    type: z.string().optional(),
    answer: z.optional(z.union([
        z.string(),
        z.array(z.string()),
        z.record(z.string(), z.string()),
    ])), // answer can be a string, array of strings, or object
    prettyFormat: z.optional(z.string()),
    sublabels: z.optional(z.string()),
    selectedField: z.optional(z.string()),
    static: z.optional(z.string()),
});
// Define the complete schema
const AnswerSchema = z.record(z.string(), FieldSchema);
exports.ContentSchema = z.object({
    id: z.string(),
    form_id: z.string(),
    ip: z.string(),
    created_at: z.string(),
    status: z.string(),
    new: z.string(),
    flag: z.string(),
    notes: z.string(),
    updated_at: z.string().nullable(),
    answers: AnswerSchema,
});
exports.FormClientResponseSchema = exports.ContentSchema.extend({
    limitAvailable: z.number(),
});
exports.FormClientResponseArraySchema = z.object({
    content: z.array(exports.ContentSchema),
    limitAvailable: z.number(),
});
